export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDH2p3EHTh3G8neF_H7J8FdbzWcAKT5HQs",
  authDomain: "walkathon-b1cae.firebaseapp.com",
  databaseURL: "https://walkathon-b1cae-default-rtdb.firebaseio.com",
  projectId: "walkathon-b1cae",
  storageBucket: "walkathon-b1cae.appspot.com",
  messagingSenderId: "35474276947",
  appId: "1:35474276947:web:09758639be08b300233ca6",
  measurementId: "G-6QVCRRCB74"
};